// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"e65c9cc2","620":"f824643e"}[chunkId] + ".chunk.js";
};